export interface AuthData {
  token: string | null;
}

export type Nullable<T> = T | null;
export type Maybe<T> = T | null | undefined;
export type ValueOf<T> = T[keyof T];
export type Optional<T> = T | null | undefined;
export const CLIENT_CRM_STATUS = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
  ARCHIVED: 'ARCHIVED',
} as const;
export type ClientCrmStatus = (typeof CLIENT_CRM_STATUS)[keyof typeof CLIENT_CRM_STATUS];

export const galleryFileTypes = {
  PDF: 'PDF',
  IMAGE: 'IMAGE',
} as const;

export type GalleryFileType = (typeof galleryFileTypes)[keyof typeof galleryFileTypes];

export const galleryTabs = {
  files: 'Files',
  folders: 'Folders',
} as const;
export const galleryTabsKeys: Record<keyof typeof galleryTabs, GalleryTabsType> = {
  files: 'files',
  folders: 'folders',
};

export type GalleryTabsType = keyof typeof galleryTabs;

export const GenderTypes = {
  FEMALE: 'FEMALE',
  MALE: 'MALE',
  UNSPECIFIED: 'UNSPECIFIED',
} as const;

export type GenderType = (typeof GenderTypes)[keyof typeof GenderTypes];

export interface BreadcrumbItem {
  icon?: React.ElementType;
  label: string;
  href: string;
}

export const fileTypes = {
  PDF: 'PDF',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  UNKNOWN: 'UNKNOWN',
} as const;

export type FileType = keyof typeof fileTypes;

export const SORT_ORDER = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

export type SortOrderType = (typeof SORT_ORDER)[keyof typeof SORT_ORDER];

export type StateDataType = {
  country_code: string;
  country_id: number;
  created_at: string;
  fips_code: string;
  flag: number;
  id: number;
  iso2: string;
  latitude: number;
  longitude: number;
  name: string;
  type: string | null;
  updated_at: string;
  wikiDataId: string;
};
